import React, {useState,useEffect} from 'react'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import {Button,makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    container: {
        textAlign: 'center'
    },
    whatsAppBtn: {
        background: '#5ECD64',
        color: '#fff',
        fontWeight: 'bolder', 
        margin: '1rem',
        '&:hover': {
            backgroundColor: '#245B52',
            borderColor: '#245B52',
            boxShadow: 'none',
          },
          '&:active': {
            boxShadow: 'none',
            backgroundColor: '#245B52',
            borderColor: '#245B52',
          },
          '&:focus': {
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
          },
    },
    icon: {
        marginRight: '5px'
    }
}))
export default function WhatsAppInquire(props){
    const classes = useStyles()
    const [siteData,setSiteData] = useState('')
    const [message,setMessage] = useState('')
    
    useEffect(()=>{
        const siteData = JSON.parse(localStorage.getItem('siteData'))
        setSiteData(siteData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        if(props.package._id) createMessage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.package])


    const createMessage = () => {
        const url = window.location.href
        const pkg = props.package
        let message = `Please send me a quote for this package\n
Package Link:\n${url}\n
Package Name:${pkg.packageName}\n
`
      
        message = encodeURI(message)
        setMessage(message)
    }

    return(
        <div className={classes.container}>
        <a 
        href={`https://wa.me/${siteData.whatsAppNumber}?text=${message}`} 
        target="_blank" rel="noopener noreferrer" >
            <Button className={classes.whatsAppBtn}>
                <WhatsAppIcon className={classes.icon} /> Inquire Now
            </Button>
        </a>
        </div>
    )
}